import React from 'react';
import { getDetectedDevice } from '../../../../utils/device-detection';
import { Link } from '../../header/header-mobile-old/Link';
import { white, blue } from '../../header/header-mobile-old/variables';
import { NewsletterFooter } from '../newsletter-footer/NewsletterFooter';
import { ContactUs } from './ContactUs';
import { __ } from '../../../../utils/translation-service';
import { LocaleConfigContext } from '../../../../contexts/locale-config/locale-config';
import { IFooterLink } from '../../../../../../interfaces';

interface IProps {
    footer: any[];
    seoFooter: any;
    phoneNumber: string;
    pageType: string;
    type: string;
}

const wrapperStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 0,
};
const styleFooterWrapper: React.CSSProperties = {
    padding: '10px 0 85px',
    textAlign: 'center',
    background: blue,
    color: white,
};
const styleFooterLinksWrapper: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    maxWidth: 420,
    margin: '0 auto',
};
const styleFooterLink: React.CSSProperties = {
    flex: '1 0 auto',
    padding: '5px',
    fontSize: 14,
    color: white,
};
const styleFooterCopyright: React.CSSProperties = {
    fontSize: 16,
};
const styleFooterBold: React.CSSProperties = {
    fontWeight: 'bold',
};
const seoTitle: React.CSSProperties = {
    color: white,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: 15,
    marginBottom: 2,
    flex: '1 0 100%',
};
const seoBlockWrapper: React.CSSProperties = {
    margin: '10px 0',
    lineHeight: 1.5,
    fontSize: 14,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
};
const seoLink: React.CSSProperties = {
    margin: '0 10px',
    color: white,
};

export const Footer = (props: IProps) => {
    const localeConfig = React.useContext(LocaleConfigContext);
    const domainEntries = Object.entries(localeConfig.domainMap);

    const domainLinks: IFooterLink[] = domainEntries
        .filter(([key, domain]) => domain !== localeConfig.url)
        .map(([key, domain]) => ({
            targetUrl: `https://www.${domain}`,
            title: domain,
        }));

    const getFooterNavigation = () => {
        return props.footer.map((item, index) => (
            <Link
                style={styleFooterLink}
                key={index}
                href={item.targetUrl}
                followLink={item.targetUrl.indexOf('http') !== -1}
            >
                <span>{item.title}</span>
            </Link>
        ));
    };

    const seoData = {
        columnOne: 'Ports of Departure',
        columnTwo: 'Countries',
        columnThree: 'Destinations',
        columnFour: 'Companies:',
        columnFive: 'ships',
    };
    const getSeoFooterNavigation = () => {
        const seoBlocks = Object.keys(seoData).map((val, idx) => {
            const seo = props.seoFooter[val];
            const seoLinks =
                seo.items &&
                seo.items.map((val: any, key: any) => (
                    <Link rel={val.linkTitle} href={val.targetUrl} key={key} style={seoLink}>
                        {val.title}
                    </Link>
                ));
            return (
                <div key={idx} style={seoBlockWrapper}>
                    <div style={seoTitle}>{seo.headline}</div>
                    {seoLinks}
                </div>
            );
        });

        const seoDomainsLink = domainLinks.map((val, key) => (
            <Link rel={val.title} href={val.targetUrl} key={key} target="_blank" style={seoLink}>
                {val.title}
            </Link>
        ));
        const seoDomains = (
            <div key={'domains'} style={seoBlockWrapper}>
                <div style={seoTitle}>{__('Our Websites')}</div>
                {seoDomainsLink}
            </div>
        );

        const allLinks = seoBlocks.concat(seoDomains);

        return allLinks;
    };
    const includeNewsletter = true; //Boolean([pageTypes.thankYouPage, pageTypes.shipDetailPage, pageTypes.frontPage, pageTypes.themeOverviewPage, pageTypes.roundtripDetailPage, pageTypes.roundtripOverviewPage].indexOf(props.pageType) >= 0);
    const showCondensedFooter = false; //Boolean(props.pageType === pageTypes.searchWizardPage);
    const deviceType = getDetectedDevice();

    return (
        <div style={wrapperStyle}>
            {includeNewsletter && <NewsletterFooter deviceType={deviceType} type={props.type} />}
            {!showCondensedFooter && <ContactUs phoneNumber={props.phoneNumber} />}
            <div style={styleFooterWrapper}>
                <div style={styleFooterLinksWrapper}>{getFooterNavigation()}</div>
                {getSeoFooterNavigation()}
                <div style={styleFooterCopyright}>
                    <span>&copy; </span>
                    <span style={styleFooterBold}>
                        {__('copyright')} {new Date().getFullYear()}
                    </span>
                </div>
            </div>
        </div>
    );
};
